import { createFileRoute } from '@tanstack/react-router';
import EmailsSentDetails from '@Views/Emails/sent/details';

export const Route = createFileRoute('/emails/(sent)/$emailId')({
    component: EmailsSentDetails,
});
